import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { theme } from "../../../../theme";


const ReasonForPurchase = ({ reason, setReason }) => {
    const options = [
        "I'm buying a property",
        "I'm selling a property",
        "I want to know my value",
        "Other",
    ];

    const handleChange = (e) => {
        setReason?.(e.target.value);
    };



    return (
        <div className="reason-for-purchase" style={{ width: '100%' }} >
            <legend>Why would you like a BPO report?</legend>
            <p className="helper-text">
                This helps us provide the most relevant analysis for your needs
            </p>
            <FormControl style={{ width: '100%' }}>
                <RadioGroup >
                    {options.map((label) => {
                        const id = `bpo-reason-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
                        return (
                            <FormControlLabel
                                sx={{ border: 'solid 0.5px', gap: '2px', marginTop: '10px', borderRadius: 2, borderColor: reason === label ? '#d1d9ff' : '#1b22', backgroundColor: reason === label ? '#EFF8FF' : '' }}
                                key={label}
                                id={id}
                                value={label}
                                control={<Radio sx={{
                                    color: 'gray', '&.Mui-checked': {
                                        color: theme.palette.secondary.main,
                                    }
                                }} />}
                                onChange={handleChange}
                                label={label}
                            />
                        );
                    })}

                </RadioGroup>
                {reason === "Other" && <div>
                    <p>
                        Please explain
                    </p>
                    <textarea placeholder="Tell us more about your specific needs..." style={{ width: '98%', minHeight: 150, borderRadius: 3, padding: 5 }} />
                </div>}
            </FormControl>


        </div>
    );
};

ReasonForPurchase.propTypes = {
    reason: PropTypes.string,
    setReason: PropTypes.func,
};

export default ReasonForPurchase;
